import { Activity, BarChart3, CheckCircle2, FileBarChart, Mail, PieChart, Sparkles } from 'lucide-react'
import { Breadcrumb } from '../../components/Breadcrumb'
import { ReportRecipientsSection } from '../../components/report-recipients/ReportRecipientsSection'
import { UsageReportIncludedCard } from '../../components/usage-report/UsageReportIncludedCard'

/** Company Admin → Usage Report. Explains what the per-company Usage Report
 *  contains and lets the admin manage who receives it (the embedded Report
 *  Recipients list). Delivery + cadence are driven by the platform's
 *  per-company usage digest; this page owns the recipient list only. */

const METRICS = [
  { icon: Activity, label: 'Active users', hint: 'Members active in the period', tone: 'sky' },
  { icon: BarChart3, label: 'Tasks created', hint: 'New tasks across the company', tone: 'violet' },
  { icon: CheckCircle2, label: 'Tasks completed', hint: 'Tasks marked done', tone: 'emerald' },
  { icon: Sparkles, label: 'AI usage', hint: 'AI tokens used', tone: 'amber' },
  { icon: Mail, label: 'Emails sent', hint: 'Notification emails delivered', tone: 'rose' },
  { icon: PieChart, label: 'Full analytics', hint: 'KPIs, task-status breakdown & employee progress — the Analytics page', tone: 'violet' },
]

export function UsageReportPage() {
  return (
    <div className="pb-16">
      <Breadcrumb current="Usage Report" />

      <div className="mb-6">
        <h1 className="font-display text-3xl text-[color:var(--color-ink-strong)] flex items-center gap-3">
          <FileBarChart
            size={22}
            className="text-[color:var(--color-accent-strong)]"
          />
          Usage Report
        </h1>
        <p className="mt-1 text-sm text-[color:var(--color-ink-muted)]">
          A periodic summary of your company&rsquo;s activity &mdash; including
          the full Analytics report (KPIs, task-status breakdown and employee
          progress) &mdash; delivered by email to the recipients you configure
          below.
        </p>
      </div>

      <UsageReportIncludedCard
        metrics={METRICS}
        footerNote="When no recipients are configured, the report goes to the company administrators instead."
      />

      {/* Recipient management — the table + Add / Edit / Enable-Disable /
       *  Remove actions. Saved on the schedule row via the existing API. */}
      <ReportRecipientsSection />
    </div>
  )
}
